import AddressRecord from "../../records/address";
import ApplicationRecord from "../../records/application";
import BeneficialOwnerRecord from "../../records/beneficial_owner";
import CompanyRecord from "../../records/company";
import GeneralLedgerRecord from "../../records/general_ledger_entry";
import MerchantRecord from "../../records/merchant";
import OrderRecord from "../../records/order";
import PaymentPlanRecord from "../../records/payment_plan";
import TransactionEntryRecord from "../../records/transaction_entry";
import UserRecord from "../../records/user";

export default {
  address: AddressRecord,
  user: UserRecord,
  application: ApplicationRecord,
  beneficial_owner: BeneficialOwnerRecord,
  order: OrderRecord,
  company: CompanyRecord,
  general_ledger_entry: GeneralLedgerRecord,
  payment_plan: PaymentPlanRecord,
  transaction_entry: TransactionEntryRecord,
  merchant: MerchantRecord
};